import {
  actualizarPreguntaGrupoInteres,
  crearPreguntaGrupoInteres,
  eliminarPreguntaGrupoInteres,
  getPreguntaGrupoInteres,
  getPreguntaGrupoInteresByfield,
} from 'api/preguntaGrupoInteres'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'preguntaGrupoInteres'
export function useObtenerPreguntaGrupoInteres(buscar) {
  return useQuery(key, () => getPreguntaGrupoInteres(buscar))
}

export function useObtenerPreguntaGrupoInteresByfield(field, value) {
  return useQuery(key, () => getPreguntaGrupoInteresByfield(field, value))
}

export function useCrearPreguntaGrupoInteres() {
  const queryClient = useQueryClient()
  return useMutation(crearPreguntaGrupoInteres, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarPreguntaGrupoInteres() {
  const queryClient = useQueryClient()
  return useMutation(actualizarPreguntaGrupoInteres, {
    onSuccess: (_, value) => {
      const { id, values: escuelaActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((preguntaGrupoInteres) => {
          let nuevoPreguntaGrupoInteres = preguntaGrupoInteres
          if (id === preguntaGrupoInteres.id) {
            nuevoPreguntaGrupoInteres = escuelaActualizado
          }
          return nuevoPreguntaGrupoInteres
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarPreguntaGrupoInteres() {
  const queryClient = useQueryClient()
  return useMutation(eliminarPreguntaGrupoInteres, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (preguntaGrupoInteres) => preguntaGrupoInteres.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function usePreguntaGrupoInteres(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarPreguntaGrupoInteres } = useEliminarPreguntaGrupoInteres()
  const { mutateAsync: actualizarPreguntaGrupoInteres } = useActualizarPreguntaGrupoInteres()
  const { mutateAsync: crearPreguntaGrupoInteres } = useCrearPreguntaGrupoInteres()
  

  const handleCrearPreguntaGrupoInteres = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearPreguntaGrupoInteres(values)
      const message = `La preguntaGrupoInteres ${data.nombre} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarPreguntaGrupoInteres = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarPreguntaGrupoInteres({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La preguntaGrupoInteres fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarPreguntaGrupoInteres = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarPreguntaGrupoInteres(id)
          const message = `La preguntaGrupoInteres ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarPreguntaGrupoInteres = async (value) => {
    queryClient.prefetchQuery(key, () => getPreguntaGrupoInteres(value))
  }

  return {
    obtenerPreguntaGrupoInteress: useObtenerPreguntaGrupoInteres,
    obtenerPreguntaGrupoInteresByfield: useObtenerPreguntaGrupoInteresByfield,
    handleEliminarPreguntaGrupoInteres,
    handleActualizarPreguntaGrupoInteres,
    handleCrearPreguntaGrupoInteres,
    handleBuscarPreguntaGrupoInteres,
  }
}
